// Lets define some vars to woks.
let wrapper;
wrapper = document.querySelector('.modal-sauron-wrapper');
const overlay = wrapper.querySelector('.overlay');
const body = document.querySelector('body')

// Manage the overlay & the modal closing.
overlay.addEventListener('click', (e) => {
  wrapper.classList.toggle('modal-show');
  const alert = wrapper.querySelector('#oscar_school_form_body .alert')
  alert.innerHTML = '';
  const modal = wrapper.querySelector(".modal-sauron")

  const file = document.getElementById(modal.getAttribute("origin"));

  file.after(modal);
  modal.style.display = 'none';
  console.log('show modal');
  body.classList.remove('hide-bot');
});

// Manage modal appearing.
for (const element of document.querySelectorAll("[id^='modal-']") ) {
  element.addEventListener('click', (e) => {

    e.preventDefault();
    wrapper.querySelector('.modal-sauron')?.remove();
    wrapper.classList.toggle('modal-show');
    console.log('hide modal');
    body.classList.add('hide-bot')

    const modal = element.nextElementSibling;
    if (modal) {
      wrapper.append(modal);
      wrapper.querySelector(".modal-sauron").style.display = 'block';
      modal.setAttribute('origin', element.getAttribute('id'));
     }
   });
}

for (const OscarForm of document.querySelectorAll('#oscar_school_form') ) {
  OscarForm.addEventListener('submit', async(event) => {
    event.preventDefault();
    var byPass = 0;

      let response = await fetch('/oscar-post', {
        method: 'POST',
        body: new FormData(OscarForm)
      });

      const result = await response.json();
      var alert = wrapper.querySelector('#oscar_school_form_body .alert')
      if (!alert) {
        byPass = 1
        alert = OscarForm.parentNode.querySelector('.alert'); //OscarForm.previousSibling; 
      }

      const message = document.createElement("p");
      alert.innerHTML = '';
      message.innerHTML = result.message;

      await alert.appendChild(message);

    if (result.status === 400) {
      alert.style.color = 'red'

      for (let items in result.errors) {

        const message = document.createElement("p");
        message.innerHTML = result.errors[items];

        await alert.append(result.errors[items], document.createElement('p'));
      }
    }

    if (result.status === 200) {
      alert.style.color = 'green'

      await OscarForm.reset()
      if (byPass === 0) {
        const modal = wrapper.querySelector(".modal-sauron")
        const file = document.getElementById(modal.getAttribute("origin"));

        window.open(file.getAttribute('href') , '_blank');
      }
    }
  });
}
